import { render, staticRenderFns } from "./ThreeDotMenuDialogList.vue?vue&type=template&id=5f394c7d&scoped=true&"
import script from "./ThreeDotMenuDialogList.vue?vue&type=script&lang=js&"
export * from "./ThreeDotMenuDialogList.vue?vue&type=script&lang=js&"
import style0 from "./ThreeDotMenuDialogList.vue?vue&type=style&index=0&id=5f394c7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f394c7d",
  null
  
)

export default component.exports